import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Pill from "../../atoms/CardPill";
import CardWrapper from "../CardWrapper";
import { getCnvAnnotation } from "../../../state/selectors/CnvComponent.selectors";
import { getPathogenicityColorByAllNames } from "../../../common/helpers/Constant";
import Card from "../Card";
import { getCardsIsCompact } from "../../../state/selectors/CardsUI.selectors";
import { getACMGClassifierHasErrors } from "../../../state/selectors/general.selectors";

const { instanceOf, string, arrayOf, shape, number } = PropTypes;

const CnvAcmgClassificationCard = ({
  card,
  acmgVerdict,
  isCompact,
  acmgClassifierError,
}) => {
  const { saphetor_class: saphetorClass } = acmgVerdict?.verdict || {};
  const color = getPathogenicityColorByAllNames(saphetorClass) || card.color;
  const pathoColor = getPathogenicityColorByAllNames("pathogenic");
  const secondaryTitle =
    isCompact && saphetorClass && !acmgClassifierError ? (
      <b style={{ color }}>{saphetorClass}</b>
    ) : null;

  return (
    <CardWrapper
      {...card}
      color={color}
      isDisabled={!acmgVerdict}
      secondaryTitle={secondaryTitle}
    >
      {saphetorClass && !acmgClassifierError && (
        <Pill inverted={false} verdict={saphetorClass} />
      )}
      {acmgClassifierError && (
        <Pill inverted={false} verdict="Error" backgroundColor={pathoColor} />
      )}
    </CardWrapper>
  );
};

CnvAcmgClassificationCard.propTypes = {
  acmgVerdict: shape({
    classifications: arrayOf(
      shape({
        acmg_class: string,
        approx_score: number,
        name: string,
        saphetor_class: string,
        saphetor_score: number,
        saphetor_user_explain: shape({
          "Likely Pathogenic": arrayOf(string),
        }),
        user_explain: shape({
          "Likely Pathogenic": arrayOf(string),
        }),
      })
    ),
    sample_findings: shape({
      patho_gene_to_diseases: arrayOf(
        shape({
          disease: arrayOf(string),
          gene: string,
        })
      ),
    }),
    verdict: shape({
      approx_score: number,
      saphetor_class: string,
      saphetor_score: number,
      verdict: string,
    }),
    version_name: string,
  }),
  card: instanceOf(Card).isRequired,
  isCompact: PropTypes.bool.isRequired,
  acmgClassifierError: PropTypes.bool,
};

CnvAcmgClassificationCard.defaultProps = {
  acmgVerdict: null,
  acmgClassifierError: false,
};

const mapStateToProps = (state) => ({
  acmgVerdict: getCnvAnnotation(state),
  isCompact: getCardsIsCompact(state),
  acmgClassifierError: getACMGClassifierHasErrors(state),
});

export default connect(mapStateToProps)(CnvAcmgClassificationCard);
